import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { AlertService, MentorListService, AppService } from '../_services/index';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseService } from '../_services/base.service';
import { EncryptionService } from '../_services/encryption.service';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-mentor-list',
  templateUrl: './mentor-list.component.html',
  styles: []
})

export class MentorListComponent implements OnInit {

  dtOptions: DataTables.Settings = {};

  mentorList: any[] = []; // Table Data list
  totalMentors: any;
  closeResult: string; // Modal Close
  filterData = { status: 'ALL' };

  mentorInfo = {
    id: '',
    type: '',
    organization_name: '',
    age_of_organization: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    type_of_organization: '',
    birth_yr: '',
    gender: '',
    address: '',
    country: '',
    country_name: '',
    state: '',
    state_name: '',
    city: '',
    city_name: '',
    qualification: '',
    qualification_name: '',
    spoken_lang: '',
    spoken_lang_names: '',
    primary_industry: '',
    primary_industry_name: '',
    stage_of_enterprise: '',
    stage_of_enterprise_names: '',
    industry_experience: '',
    industry_experience_name: '',
    area_of_functional_expertise: '',
    area_of_functional_expertise_name: '',
    provide_mentoring: '',
    kind_of_mentoring_name: '',
    preferred_track_of_mentorship: '',
    track_of_mentorship_names: '',
    ecosystem_key: '',
    ecosystem_key_names: '',
    preference_across: '',
    preference_across_name: '',
    mode_of_engagement: '',
    mode_of_engagement_name: '',
    willing_no_of_mentees: '',
    willing_no_of_mentees_name: '',
    no_of_hours_per_month: '',
    no_of_hours_per_month_name: '',
    linkedin_profile_url: '',
    approve_status: '',
    remark: '',
    profileimage: '',
    document: '',
  };

  constructor(
    public router: Router,
    private dataService: MentorListService,
    private enc_dec: EncryptionService,
    private http: HttpClient,
    private alertService: AlertService,
    private AppService: AppService,
    private modalService: NgbModal
  ) { }

  modalReference: NgbActiveModal;
  modalTitle: string;
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    if (localStorage.getItem('mentor_approve_status') != null) {
      this.filterData.status = localStorage.getItem('mentor_approve_status');
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .post<DataTablesResponse>(
            '/api/all-mentor-by-status',
            { 'req_data': this.enc_dec.encrypt(JSON.stringify(Object.assign(dataTablesParameters, this.filterData))) }, {}
          ).subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            var resp = JSON.parse(output);
            this.mentorList = resp['data'];
            this.totalMentors = resp['recordsTotal'];
            callback({
              recordsTotal: resp['recordsTotal'],
              recordsFiltered: resp['recordsFiltered'],
              data: []
            });
          });
      },
      columns: [{ data: 'id' }, { data: 'name' }, { data: 'email' }, { data: 'mobile' }, { data: 'approve_status' }, { data: 'action' }]
    };
    this.loadHide();
    window.scroll(0, 0);
  }

  openMentorInfo(id, mentorinfo_ind) {
    this.loadShow();
    this.dataService.getMentorInfo(id)
      .pipe().subscribe(data => {
        console.log(data)
        let mentors = data['data'];
        this.mentorInfo = {
          id: mentors.id,
          type: mentors.type,
          organization_name: mentors.organization_name,
          age_of_organization: mentors.age_of_organization,
          first_name: mentors.first_name,
          last_name: mentors.last_name,
          email: mentors.email,
          mobile: mentors.mobile,
          type_of_organization: mentors.type_of_organization,
          birth_yr: mentors.birth_yr,
          gender: mentors.gender,
          address: mentors.address,
          country: mentors.country,
          country_name: mentors.country_name,
          state: mentors.state,
          state_name: mentors.state_name,
          city: mentors.city,
          city_name: mentors.city_name,
          qualification: mentors.qualification,
          qualification_name: mentors.qualification_name,
          spoken_lang: mentors.spoken_lang,
          spoken_lang_names: mentors.spoken_lang_names,
          primary_industry: mentors.primary_industry,
          primary_industry_name: mentors.primary_industry_name,
          stage_of_enterprise: mentors.stage_of_enterprise,
          stage_of_enterprise_names: mentors.stage_of_enterprise_names,
          industry_experience: mentors.industry_experience,
          industry_experience_name: mentors.industry_experience_name,
          area_of_functional_expertise: mentors.area_of_functional_expertise,
          area_of_functional_expertise_name: mentors.area_of_functional_expertise_name,
          provide_mentoring: mentors.provide_mentoring,
          kind_of_mentoring_name: mentors.kind_of_mentoring_name,
          preferred_track_of_mentorship: mentors.preferred_track_of_mentorship,
          track_of_mentorship_names: mentors.track_of_mentorship_names,
          ecosystem_key: mentors.ecosystem_key,
          ecosystem_key_names: mentors.ecosystem_key_names,
          preference_across: mentors.preference_across,
          preference_across_name: mentors.preference_across_name,
          mode_of_engagement: mentors.mode_of_engagement,
          mode_of_engagement_name: mentors.mode_of_engagement_name,
          willing_no_of_mentees: mentors.willing_no_of_mentees,
          willing_no_of_mentees_name: mentors.willing_no_of_mentees_name,
          no_of_hours_per_month: mentors.no_of_hours_per_month,
          no_of_hours_per_month_name: mentors.no_of_hours_per_month_name,
          linkedin_profile_url: mentors.linkedin_profile_url,
          approve_status: mentors.approve_status,
          remark: mentors.remark,
          profileimage: mentors.profileimage,
          document: mentors.document
        };
        this.loadHide();
      });
   
    this.modalReference = this.modalService.open(mentorinfo_ind);
  }

  mentorStatusUpdate(item: any, mentorinfo_ind) {
    // console.log(item);
    this.loadShow();
    var data = {
      "mentor_id": this.mentorInfo.id,
      "status": this.mentorInfo.approve_status,
      "remarks": this.mentorInfo.remark,
    };
    
    this.dataService.updateMentorStatus(data)
      .pipe().subscribe(res => {
        if (res['status'] == 200) {
          this.alertService.success(res['mesg'], true);          
        } else if (res['status'] == 422) {
          this.alertService.error(res['mesg'], true);
        }
        this.loadHide()
        this.modalService.dismissAll(mentorinfo_ind);
      }, error => {
        this.alertService.error(error);
        this.loadHide()
      });
  }

  setFilterData(e: any) {
    this.filterData.status = e.target.value;
    localStorage.setItem('mentor_approve_status', this.filterData.status);
    window.location.reload();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

}
